import React, { useEffect, useRef } from "react";
import "../Projects/Projects.css";

const Project = () => {
  const projects = [
    { title: "OFFICE HUBS", image: "office-hubs.webp" },
    { title: "RETAIL & HOSPITALITY", image: "hospitality.webp" },
    { title: "RESIDENTIAL ABODES", image: "residential-abodes.webp" },
    { title: "FARMS & VILLAS", image: "farms-villas.webp" },
  ];

  const projectRef = useRef([]);

  useEffect(() => {
    projectRef.current.forEach((project, index) => {
      setTimeout(() => {
        project.classList.add("slide-up");
      }, index * 100); // Stagger the animations
    });
  }, []);

  return (
    <div className="project-section">
      <h2>
        Our <span>Projects</span>
      </h2>
      <div className="project-grid">
        {projects.map((project, index) => (
          <div
            key={index}
            className="project-card"
            ref={(el) => (projectRef.current[index] = el)}
            style={{ backgroundImage: `url(${project.image})` }}
          >
            <div className="overlay">
              <h3>{project.title}</h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Project;
